module.exports = __webpack_public_path__ + "static/media/IlotA_mall_3.0f5b4209.webp";